var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoubleMark = function SvgDoubleMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.32.71a.983.983 0 0 0-1.4 0L5.26 7.476a1 1 0 0 1-1.426 0L2.055 5.661A.983.983 0 1 0 .653 7.04l3.181 3.235a1 1 0 0 0 1.426.001l8.06-8.186a.983.983 0 0 0 0-1.38ZM9.348 8.404a.983.983 0 0 0 0 1.38l.487.494a1 1 0 0 0 1.425 0l8.06-8.188a.983.983 0 1 0-1.4-1.38l-7.125 7.236a.35.35 0 0 1-.499 0 .35.35 0 0 0-.5 0l-.45.458Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
};
export default SvgDoubleMark;